import { render, staticRenderFns } from "./UploadModel.vue?vue&type=template&id=30501e24&"
import script from "./UploadModel.vue?vue&type=script&lang=js&"
export * from "./UploadModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports